<app-resource-form-card
  [title]="service.title()"
  [resource]="service.resource"
  [createButton]="access()?.advertising?.actions?.create"
  [detailed]="detailed()"
  [list]="true"
>
  <p-table
    [value]="value()?.data ?? []"
    [paginator]="true"
    [rows]="rows"
    [rowsPerPageOptions]="[5, 10, 20]"
    [scrollable]="true"
    scrollHeight="flex"
    (onFilter)="onFilters($event)"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th pSortableColumn="name" class="min-w-32">
          Nombre <p-sortIcon field="name" />
        </th>
        @if (detailed()) {
        <th>Descripción</th>
        } @if (access()?.image?.actions?.read) {
        <th>Imagenes</th>
        } @if (detailed()) { @if (access()?.user?.actions?.read) {
        <th pSortableColumn="tablets" class="min-w-52">
          Usuarios <p-sortIcon field="tablets" />
        </th>
        } @if (access()?.contract?.actions?.read) {
        <th pSortableColumn="contract.name" class="min-w-48">
          Contrato <p-sortIcon field="contract.name" />
        </th>
        } @if (access()?.branch?.actions?.read) {
        <th pSortableColumn="branches" class="min-w-48">
          Sucursales <p-sortIcon field="branches" />
        </th>
        } }
        <th class="action">Acciones</th>
      </tr>
      @if (detailed()) {
      <tr>
        <th>
          <p-columnFilter
            type="text"
            field="name"
            placeholder="Nombre"
            ariaLabel="Filter Name"
          />
        </th>
        <th>
          <p-columnFilter
            type="text"
            field="description"
            placeholder="Descripción"
            ariaLabel="Filter Name"
            [showMenu]="true"
          />
        </th>
        @if (access()?.image?.actions?.read) {
        <th></th>
        }
        @if (access()?.user?.actions?.read) {
        <th>
          <!-- <p-columnFilter
            field="tablets"
            matchMode="in"
            [showMenu]="false"
          >
            <ng-template
              pTemplate="filter"
              let-value
              let-filter="filterCallback"
            >
              <p-multiSelect
                [ngModel]="value"
                [options]="display()"
                placeholder="Usuarios"
                (onChange)="filter($event.value)"
                optionLabel="username"
              >
                <ng-template let-option pTemplate="item">
                  <div class="inline-block vertical-align-middle">
                    <span class="ml-1 mt-1">
                      {{ option.username }}
                    </span>
                  </div>
                </ng-template>
              </p-multiSelect>
            </ng-template>
          </p-columnFilter> -->
        </th>
        }
        @if (access()?.contract?.actions?.read) {
        <th>
          <p-columnFilter
            field="contract"
            matchMode="in"
            [showMenu]="false"
          >
            <ng-template
              pTemplate="filter"
              let-value
              let-filter="filterCallback"
            >
              <p-multiSelect
                [ngModel]="value"
                [options]="contracts()"
                placeholder="Usuarios"
                (onChange)="filter($event.value)"
                optionLabel="name"
              >
                <ng-template let-option pTemplate="item">
                  <div class="inline-block vertical-align-middle">
                    <!-- <img
                      [alt]="option.label"
                      src="https://primefaces.org/cdn/primeng/images/demo/avatar/{{
                        option.image
                      }}"
                      width="24"
                      class="vertical-align-middle"
                    /> -->
                    <span class="ml-1 mt-1">
                      {{ option.name }}
                    </span>
                  </div>
                </ng-template>
              </p-multiSelect>
            </ng-template>
          </p-columnFilter>
        </th>
        }
        @if (access()?.branch?.actions?.read) {
        <th>
          <p-columnFilter
            field="branch"
            matchMode="in"
            [showMenu]="false"
          >
            <ng-template
              pTemplate="filter"
              let-value
              let-filter="filterCallback"
            >
              <p-multiSelect
                [ngModel]="value"
                [options]="branches()"
                placeholder="Sucursales"
                (onChange)="filter($event.value)"
                optionLabel="name"
              >
                <ng-template let-option pTemplate="item">
                  <div class="inline-block vertical-align-middle">
                    <!-- <img
                      [alt]="option.label"
                      src="https://primefaces.org/cdn/primeng/images/demo/avatar/{{
                        option.image
                      }}"
                      width="24"
                      class="vertical-align-middle"
                    /> -->
                    <span class="ml-1 mt-1">
                      {{ option.name }}
                    </span>
                  </div>
                </ng-template>
              </p-multiSelect>
            </ng-template>
          </p-columnFilter>
        </th>
        }
        <th></th>
      </tr>
      }
    </ng-template>
    <ng-template pTemplate="body" let-value>
      <tr>
        <td>{{ value?.name }}</td>
        @if (detailed()) {
        <td>{{ value?.description }}</td>
        } @if (access()?.image?.actions?.read) {
        <td>
          <p-galleria
            [value]="value?.images"
            [autoPlay]="true"
            [circular]="true"
            [showIndicators]="false"
            [showThumbnails]="false"
            [showItemNavigators]="true"
            [containerStyle]="{ 'max-width': '640px' }"
            [numVisible]="5"
          >
            <ng-template pTemplate="item" let-item>
              @if (service.isImage(item)) {
              <p-image
                [src]="item.formattedImageURL"
                [alt]="value.name"
                width="500"
                [preview]="true"
              />
              } @else if (service.isVideo(item)) {
              <video
                [src]="item.formattedImageURL"
                controls
                width="500"
                class="resource-thumbnail"
              ></video>
              } @else {
              <div class="no-preview-placeholder">
                <i class="pi pi-file"></i> No hay previsualización
              </div>
              }
            </ng-template>
          </p-galleria>
          <!-- <p-image [src]="url + value?.image?.file_name"  [alt]="value?.image?.name" width="100" [preview]="true"/> -->
        </td>
        } @if (detailed()) { @if (access()?.user?.actions?.read) {
        <td>
          @if (value.tablets) { @for (tablet of value.tablets; track $index) {
          <p-chip [label]="$index + 1 + ' - ' + tablet?.username" />
          } } @else {
          {{ "El anuncio no esta asignado a una pantalla" }}
          }
        </td>
        } @if (access()?.contract?.actions?.read) {
        <td>
          {{
            value.contract?.name ?? "El anuncio no tiene un contrato asignado"
          }}
        </td>
        } @if (access()?.branch?.actions?.read) {
        <td>
          @if (value.branches) { @for (branch of value.branches; track $index) {
          <p-chip [label]="$index + 1 + ' - ' + branch.name" />
          } } @else {
          {{ "El anuncio no esta asignado a una sucursal" }}
          }
        </td>
        } }
        <td>
          <app-resource-button-group
            [resource]="resource"
            [resourceId]="value._id"
            [iconOnly]="true"
            [detailsButton]="true"
            [editButton]="access()?.advertising?.actions?.update"
            [deleteButton]="access()?.advertising?.actions?.delete"
          ></app-resource-button-group>
        </td>
      </tr>
    </ng-template>
  </p-table>
</app-resource-form-card>
